import { render } from "./plasticFreeVideo.vue?vue&type=template&id=53940b82&scoped=true&bindings={\"navigate\":\"props\"}"
import script from "./plasticFreeVideo.vue?vue&type=script&lang=js"
export * from "./plasticFreeVideo.vue?vue&type=script&lang=js"

import "./plasticFreeVideo.vue?vue&type=style&index=0&id=53940b82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53940b82"
/* custom blocks */
import block0 from "./plasticFreeVideo.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script